import * as React from 'react';
import { theme } from '../../theme';
import LogoSvg from './LogoSvg';
const DEFAULT_HEIGHT = 24;
const logoColours = (color) => {
    switch (color) {
        case 'white':
            return {
                text: theme.colors.LM_NU0,
                main: theme.colors.LM_NU0,
            };
        case 'grey':
            return { text: theme.colors.LM_NU70, main: theme.colors.LM_NU70 };
        case 'darkbg':
            return {
                text: theme.colors.LM_NU0,
                main: theme.colors.BB100,
            };
        case 'lightbg':
            return {
                text: theme.colors.LM_NU100,
                main: theme.colors.BB100,
            };
        default:
            return {
                text: theme.colors.LM_NU0,
                main: theme.colors.BB100,
            };
    }
};
/**
 * The Logo component renders one of 4 possible colour variants for the logo, as defined in the referenced designs.
 * It can be configured to render either the full logo, with company text, or the logomark which is the square icon only.
 * Size is configured by setting the height property - width is dynamic based on the type of logo being rendered.
 */
export const Logo = (props) => {
    var _a, _b, _c;
    const colors = logoColours((_b = (_a = props.variant) !== null && _a !== void 0 ? _a : props.color) !== null && _b !== void 0 ? _b : 'darkbg');
    return (React.createElement(LogoSvg, Object.assign({}, props, colors, { height: (_c = props.height) !== null && _c !== void 0 ? _c : DEFAULT_HEIGHT })));
};
//# sourceMappingURL=Logo.js.map